import Permissions from 'models/Permissions'

class PermissionsDto extends Map {
    static fromJson(dataFromAPI) {
        const permissions = new PermissionsDto(dataFromAPI.map(({ name, value }) => [name, value]))

        return new Permissions({
            scenes: {
                privileges: {
                    organizer: {
                        show: permissions.get('organizer.show'),
                    },
                    parent: {
                        show: permissions.get('brokerParent.show'),
                        sellerName: permissions.get('brokerParent.sellerName.show'),
                    },
                },
                profile: {
                    commercialTerms: {
                        show: permissions.get('commissions.show'),
                    },
                    selfManagementPlatformLogo: {
                        update: permissions.get('broker.logo.update'),
                    },
                },
                dashboard: {
                    show: permissions.get('dashboard.show'),
                    carousel: {
                        show: permissions.get('carousel.show'),
                    },
                    manual: {
                        show: permissions.get('broker.manual.show'),
                    }
                },
                clients: {
                    loan: {
                        enabled: permissions.get('clients.loan.enabled'),
                        show: permissions.get('clients.loan.show'),
                    },
                },
                quoteCreation: {
                    multiquote: {
                        debug: {
                            show: permissions.get('multiquote.debug.show'),
                        },
                        error: {
                            show: permissions.get('multiquote.error.show'),
                        },
                        fullCoverages: {
                            show: permissions.get('multiquote.fullCoverages.show'),
                        },
                        car: {
                            enabled: permissions.get('multiquote.car.enabled'),
                            show: permissions.get('multiquote.car.show'),
                        },
                        motorcycle: {
                            enabled: permissions.get('multiquote.motorcycle.enabled'),
                            show: permissions.get('multiquote.motorcycle.show'),
                        },
                        home: {
                            enabled: permissions.get('multiquote.home.enabled'),
                            show: permissions.get('multiquote.home.show'),
                        },
                        commerce: {
                            enabled: permissions.get('multiquote.commerce.enabled'),
                            show: permissions.get('multiquote.commerce.show'),
                        },
                        consortium: {
                            enabled: permissions.get('multiquote.consortium.enabled'),
                            show: permissions.get('multiquote.consortium.show'),
                        },
                        life: {
                            enabled: permissions.get('multiquote.life.enabled'),
                            show: permissions.get('multiquote.life.show'),
                        },
                        bicycle: {
                            enabled: permissions.get('multiquote.bicycle.enabled'),
                            show: permissions.get('multiquote.bicycle.show'),
                        },
                        computer: {
                            enabled: permissions.get('multiquote.computer.enabled'),
                            show: permissions.get('multiquote.computer.show'),
                        },
                        phone: {
                            enabled: permissions.get('multiquote.phone.enabled'),
                            show: permissions.get('multiquote.phone.show'),
                        },
                        mobility: {
                            enabled: permissions.get('multiquote.mobility.enabled'),
                            show: permissions.get('multiquote.mobility.show'),
                        },
                        guaranteeInsurance: {
                            enabled: permissions.get('multiquote.guaranteeInsurance.enabled'),
                            show: permissions.get('multiquote.guaranteeInsurance.show'),
                        },
                        civilResponsibility: {
                            enabled: permissions.get('multiquote.civilResponsibility.enabled'),
                            show: permissions.get('multiquote.civilResponsibility.show'),
                        },
                        transport: {
                            enabled: permissions.get('multiquote.transport.enabled'),
                            show: permissions.get('multiquote.transport.show'),
                        },
                        others: {
                            enabled: permissions.get('multiquote.others.enabled'),
                            show: permissions.get('multiquote.others.show'),
                        },
                    },
                    emissions: {
                        car: {
                            enabled: permissions.get('emissions.car.enabled'),
                        },
                        motorcycle: {
                            enabled: permissions.get('emissions.motorcycle.enabled'),
                        },
                        home: {
                            enabled: permissions.get('emissions.home.enabled'),
                        },
                        commerce: {
                            enabled: permissions.get('emissions.commerce.enabled'),
                        },
                        consortium: {
                            enabled: permissions.get('emissions.consortium.enabled'),
                        },
                        life: {
                            enabled: permissions.get('emissions.life.enabled'),
                        },
                        bicycle: {
                            enabled: permissions.get('emissions.bicycle.enabled'),
                        },
                        computer: {
                            enabled: permissions.get('emissions.computer.enabled'),
                        },
                        phone: {
                            enabled: permissions.get('emissions.phone.enabled'),
                        },
                        mobility: {
                            enabled: permissions.get('emissions.mobility.enabled'),
                        },
                        guaranteeInsurance: {
                            enabled: permissions.get('emissions.guaranteeInsurance.enabled'),
                        },
                        civilResponsibility: {
                            enabled: permissions.get('emissions.civilResponsibility.enabled'),
                        },
                        transport: {
                            enabled: permissions.get('emissions.transport.enabled'),
                        },
                        others: {
                            enabled: permissions.get('emissions.others.enabled'),
                        },
                        loan: {
                            enabled: permissions.get('emissions.loan.enabled'),
                        },
                    },
                },
                policy: {
                    manual: {
                        show: permissions.get('policies.manual.show'),
                        create: permissions.get('policies.manual.create'),
                        update: permissions.get('policies.manual.update'),
                        remove: permissions.get('policies.manual.delete'),
                    },
                },
                policyDetails: {},
                currentAccount: {
                    show: permissions.get('dashboard.show'),
                },
                commercialConditions: {
                    show: permissions.get('dashboard.show'),
                },
                comunications: {
                    show: permissions.get('comunications.show'),
                },
                withholdings: {
                    show: permissions.get('withholdings.list.show'),
                },
                commissions: {
                    show: permissions.get('commissions.show'),
                    update: permissions.get('commissions.update'),
                },
            },
        })
    }
}

export default PermissionsDto
